import { HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest, HttpResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { ObservabilityService } from './observability.service';

export const observabilityInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
  const obs = inject(ObservabilityService);
  const startTime = performance.now();

  const correlationId =
    req.headers.get('X-Correlation-ID') ||
    (typeof localStorage !== 'undefined' ? localStorage.getItem('correlation-id') : null) ||
    crypto.randomUUID();

  // Ensure correlation ID is always attached to headers
  const tracedReq = req.headers.has('X-Correlation-ID')
    ? req
    : req.clone({
        headers: req.headers.set('X-Correlation-ID', correlationId)
      });

  obs.debug('HTTP', `--> ${tracedReq.method} ${tracedReq.url}`, {
    correlationId,
    headers: tracedReq.headers.keys()
  });

  return next(tracedReq).pipe(
    tap({
      next: (event: HttpEvent<unknown>) => {
        if (event instanceof HttpResponse) {
          const duration = Math.round(performance.now() - startTime);
          obs.info('HTTP', `<-- ${tracedReq.method} ${tracedReq.url} [${event.status}] ${duration}ms`, {
            correlationId,
            status: event.status,
            durationMs: duration
          });
          obs.trackMetric('http_request_duration_ms', duration, {
            url: tracedReq.url,
            method: tracedReq.method,
            status: String(event.status)
          });
        }
      },
      error: (error: unknown) => {
        const duration = Math.round(performance.now() - startTime);
        if (error instanceof HttpErrorResponse) {
          const backendCode = error.error?.error?.code || error.error?.code;
          const backendMsg = error.error?.error?.message || error.error?.message;

          obs.error(
            'HTTP',
            `XX- ${tracedReq.method} ${tracedReq.url} failed with status ${error.status} in ${duration}ms`,
            error,
            {
              correlationId,
              status: error.status,
              statusText: error.statusText,
              durationMs: duration,
              backendCode,
              backendMessage: backendMsg
            }
          );
          obs.trackMetric('http_request_error_count', 1, {
            url: tracedReq.url,
            method: tracedReq.method,
            status: String(error.status)
          });
        } else {
          obs.error('HTTP', `XX- ${tracedReq.method} ${tracedReq.url} network failure in ${duration}ms`, error);
        }
      }
    })
  );
};

